import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" })
  ])
], -1)
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "mb-13 text-center" }
const _hoisted_5 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_7 = {
  key: 2,
  class: "text-gray-400 fw-bold fs-5"
}
const _hoisted_8 = {
  key: 3,
  class: "text-gray-400 fw-bold fs-5"
}
const _hoisted_9 = { class: "text-center mb-8" }
const _hoisted_10 = ["data-kt-indicator"]
const _hoisted_11 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Uložiť ")
const _hoisted_13 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_14 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Počkajte prosím... ")
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "text-center mb-8" }
const _hoisted_19 = ["data-kt-indicator"]
const _hoisted_20 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Uložiť ")
const _hoisted_22 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_23 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Počkajte prosím... ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_flag = _resolveComponent("country-flag")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_ctx.cardWrapper)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.$route.params.key)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.pageTitleNew), 1))
              : _createCommentVNode("", true),
            (_ctx.$route.params.key)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_6, _toDisplayString(_ctx.pageTitleEdit), 1))
              : _createCommentVNode("", true),
            (!_ctx.$route.params.key)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.pageSubtitleNew), 1))
              : _createCommentVNode("", true),
            (_ctx.$route.params.key)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.pageSubtitleEdit), 1))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_form, {
            id: "new_record_form",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
            model: _ctx.localFieldValues,
            rules: _ctx.localFieldRules,
            ref: "formRef",
            class: "form"
          }, {
            default: _withCtx(() => [
              (_ctx.multilanguage)
                ? (_openBlock(), _createBlock(_component_el_tabs, {
                    key: 0,
                    type: "border-card",
                    class: "mb-5"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
                        return (_openBlock(), _createBlock(_component_el_tab_pane, {
                          key: language.shortcut,
                          class: "p-5"
                        }, {
                          label: _withCtx(() => [
                            _createElementVNode("span", null, [
                              _createVNode(_component_country_flag, {
                                country: language.shortcut,
                                size: "small"
                              }, null, 8, ["country"]),
                              _createTextVNode(" " + _toDisplayString(language.title), 1)
                            ])
                          ]),
                          default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default", { language: language })
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 3
                  }))
                : _renderSlot(_ctx.$slots, "default", { key: 1 }),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "reset",
                  id: "new_record_cancel",
                  class: "btn btn-white me-3",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_ctx.listPageRouter)))
                }, "Zrušiť"),
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-primary",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, _hoisted_17))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_10)
              ])
            ]),
            _: 3
          }, 8, ["model", "rules"])
        ])
      ]))
    : (_openBlock(), _createBlock(_component_el_form, {
        key: 1,
        id: "new_record_form",
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
        model: _ctx.localFieldValues,
        rules: _ctx.localFieldRules,
        ref: "formRef",
        class: "form"
      }, {
        default: _withCtx(() => [
          (_ctx.multilanguage)
            ? (_openBlock(), _createBlock(_component_el_tabs, {
                key: 0,
                type: "border-card",
                class: "mb-5"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language) => {
                    return (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: language.shortcut,
                      class: "p-5"
                    }, {
                      label: _withCtx(() => [
                        _createElementVNode("span", null, [
                          _createVNode(_component_country_flag, {
                            country: language.shortcut,
                            size: "small"
                          }, null, 8, ["country"]),
                          _createTextVNode(" " + _toDisplayString(language.title), 1)
                        ])
                      ]),
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "default", { language: language })
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 3
              }))
            : _renderSlot(_ctx.$slots, "default", { key: 1 }),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              type: "reset",
              id: "new_record_cancel",
              class: "btn btn-white me-3",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(_ctx.listPageRouter)))
            }, "Zrušiť"),
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-primary",
              type: "submit"
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_23, _hoisted_26))
                : _createCommentVNode("", true)
            ], 8, _hoisted_19)
          ])
        ]),
        _: 3
      }, 8, ["model", "rules"]))
}